import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromEvent } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { PushNotificationsActions } from '@app/root-store/push-notifications-store';
import { RootState } from '@app/root-store/root-state';
import { isFromMobileApp } from '@app/core/helpers/from-mobile-app';

@Injectable({ providedIn: 'root' })
export class VisibilityService {
  private store = inject(Store<RootState>);

  visibilityChange(): void {
    fromEvent(document, 'visibilitychange')
      .pipe(
        debounceTime(30000),
        filter(() => !document.hidden && !isFromMobileApp()),
      )
      .subscribe(() => {
        this.store.dispatch(PushNotificationsActions.loadCounterRequest());
      });
  }
}
